import { sortByPosition } from '../../../utils/helper';

export const getListAfterStart = (list, collection, parentIndex) => {
  if (collection === 'level-0') {
    return list.map((item) => ({
      ...item,
      children: [],
    }))
  }
  if (collection === 'level-1') {
    return list.map((item, index) => ({
      ...item,
      children: item.children.map((subcategory) => {
        if (Number(parentIndex) === index) {
          return {
            ...subcategory,
            children: [],
          }
        }
        return {
          ...subcategory,
        };
      }),
    }))
  }
  return list;
}

export const createList = (list) => {
  const recursive = (item) => item.map((item) => {
    const isAddField = item.item === 0 && item?.children?.length ? (!item.children.find((subcategory) => subcategory.item === 1)) : true
    return {
      ...item,
      collection: `level-${item.item}`,
      isAddField,
      children: item?.children?.length ? recursive(item?.children) : [],
    }
  })
  return recursive(list.sort(sortByPosition))
}
